import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AuthenticationGate from './ui/AuthenticationGate';

const ProtectedRoute = ({ 
  children, 
  requirePremium = false,
  requiredRole = null,
  fallbackContent = null,
  className = ''
}) => {
  const { user, userProfile, loading } = useAuth();

  // Show loading while authentication state is being determined
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Check role-based access
  if (requiredRole && userProfile?.role !== requiredRole) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4 max-w-md mx-auto p-6">
          <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mx-auto">
            <svg className="w-8 h-8 text-destructive" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-foreground">Access Denied</h2>
          <p className="text-muted-foreground">
            You need {requiredRole} privileges to access this page.
          </p>
        </div>
      </div>
    );
  }

  return (
    <AuthenticationGate 
      requireAuth={true}
      requirePremium={requirePremium}
      fallbackContent={fallbackContent}
      className={className}
    >
      {children}
    </AuthenticationGate>
  );
};

export default ProtectedRoute;